module.exports = __webpack_public_path__ + "media/images/time_icon-17e1b6aceb03142f5750346b6741d0cf.svg";